import "../components/styles.css";
import React from "react";
import CalendarPicker from "../components/calendar-picker";
import Time from "../components/time";

export default function CheckInOut({
  onSelectedDateFrom,
  value,
  is24HoursFormat,
  timeFrom,
  onSelectTimeFrom,
}) {
  return (
    <div className="check-in-out-container" id="check-in-out-container">
      <CalendarPicker
        label={"From"}
        isStanAlone={false}
        onSelected={(value, str) => onSelectedDateFrom(value, str)}
        value={value}
        id="check-in-out-calendar-component"
      />
      <Time
        label={"Time"}
        ampm={!is24HoursFormat}
        value={timeFrom}
        onChange={(value) => onSelectTimeFrom?.(value)}
        id="check-in-out-time-component"
      />
    </div>
  );
}
